import React from "react";
import { styled } from "@mui/material/styles";
import { Button, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { Link } from "react-router-dom";
import TruncateText from "../../components/common/TruncateText";
import { viewPath } from "../../utils/routeUtils";

const PREFIX = "HazardTable";

const classes = {
  root: `${PREFIX}-root`,
  root2: `${PREFIX}-root2`,
  table: `${PREFIX}-table`,
  tableCell: `${PREFIX}-tableCell`,
};

const StyledPaper = styled(Paper)({
  [`& .${classes.root2}`]: {
    marginTop: "40px",
    marginBottom: "40px",
  },
  [`& .${classes.table}`]: {
    tableLayout: "fixed",
    wordWrap: "break-word",
  },
  [`& .${classes.tableCell}`]: {
    borderBottom: "none",
  },
});

const AlternatingRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export interface HazardTableProps {
  solution_page: boolean;
  readonly hazard_solution?:
    | {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        readonly created: any | null | undefined;
        readonly csv_archive:
          | {
              readonly file_name: string | null | undefined;
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              readonly file_size: any | null | undefined;
              readonly file_url: string | null | undefined;
              readonly id: string;
            }
          | null
          | undefined;
        readonly hdf5_archive:
          | {
              readonly file_name: string | null | undefined;
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              readonly file_size: any | null | undefined;
              readonly file_url: string | null | undefined;
              readonly id: string;
            }
          | null
          | undefined;
        readonly id: string;
      }
    | null
    | undefined;
}

const HazardTable: React.FC<HazardTableProps> = ({ hazard_solution, solution_page }: HazardTableProps) => {
  return (
    <StyledPaper className={classes.root}>
      <Table stickyHeader size="small" className={classes.table}>
        <colgroup>
          <col style={{ width: "50%" }} />
        </colgroup>
        <TableHead>
          <AlternatingRow
            classes={{
              root: classes.root,
            }}
          >
            <TableCell colSpan={3}>Hazard Solution</TableCell>
          </AlternatingRow>
        </TableHead>
        <TableBody>
          {!solution_page && (
            <AlternatingRow
              classes={{
                root: classes.root,
              }}
            >
              <TableCell colSpan={2}>{hazard_solution?.id}</TableCell>
              <TableCell>
                <Button component={Link} to={viewPath(hazard_solution?.id)}>
                  more
                </Button>
              </TableCell>
            </AlternatingRow>
          )}

          <AlternatingRow
            classes={{
              root: classes.root,
            }}
          >
            <TableCell>
              <TruncateText text={hazard_solution?.csv_archive?.file_name ?? ""} />
            </TableCell>
            <TableCell>
              <Button href={hazard_solution?.csv_archive?.file_url ?? ""}>Download</Button>
            </TableCell>
            <TableCell>
              <Button component={Link} to={viewPath(hazard_solution?.csv_archive?.id)}>
                more
              </Button>
            </TableCell>
          </AlternatingRow>
          <AlternatingRow
            classes={{
              root: classes.root,
            }}
          >
            <TableCell>
              <TruncateText text={hazard_solution?.hdf5_archive?.file_name ?? ""} />
            </TableCell>
            <TableCell>
              <Button variant="outlined" href={hazard_solution?.hdf5_archive?.file_url ?? ""}>
                Download
              </Button>
            </TableCell>
            <TableCell>
              <Button variant="outlined" component={Link} to={viewPath(hazard_solution?.hdf5_archive?.id)}>
                more
              </Button>
            </TableCell>
          </AlternatingRow>
        </TableBody>
      </Table>
    </StyledPaper>
  );
};

export default HazardTable;
